export default __webpack_public_path__ + "static/media/oppa_pdf_sample.d612f69c.png";